import logo from './logo.svg';
import './App.css';
import Login from './Pages/Login';
import Navbar from './Components/Navbar';
import MainRoute from './Components/MainRoute';


function App() {
  return (
    <div>
    <Navbar/>
    <MainRoute/>
   </div>
  );
}

export default App;
